import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
            <i className="ri-question-answer-line text-primary-500 mr-2"></i>
            常见问题解答
          </h2>
          <div className="space-y-3">
            {faqData.map((faq) => (
              <div
                key={faq.id}
                className="bg-background-50 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {faq.question}
                  </h3>
                  <i className={`text-lg text-foreground-500 transition-transform flex-shrink-0 ${
                    openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </button>
                {openId === faq.id && (
                  <div className="px-4 md:px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}